import React from 'react';
import PublicLayout, { PublicHero, PUBLIC_CONTACT_EMAIL } from '../../components/layout/PublicLayout';
import { UserCog, KeyRound, FileText, ShieldCheck, Trash2, Mail } from 'lucide-react';

const cats = [
  { icon: UserCog, title: 'Account support', desc: 'Help with your profile, account details and general access.' },
  { icon: KeyRound, title: 'Login & access', desc: 'Trouble signing in or accessing your workspace.' },
  { icon: FileText, title: 'LIOS support', desc: 'Questions about using LIOS and your documents.' },
  { icon: ShieldCheck, title: 'Privacy', desc: 'Questions about how your information is handled.' },
  { icon: Trash2, title: 'Deletion', desc: 'Requests to delete your account or specific data.' },
];

const Help = () => (
  <PublicLayout title="Help & Support" description="Get help with VSKR Legal and LIOS — account, access, privacy and deletion support.">
    <PublicHero eyebrow="Help & Support" title="We're here to help"
      subtitle="Find the right support category below, then reach us by email. We aim to respond thoughtfully to every request." />
    <section className="max-w-7xl mx-auto px-5 lg:px-8 pb-12">
      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {cats.map((c) => (
          <div key={c.title} className="glass-card p-6 rounded-2xl">
            <div className="w-11 h-11 rounded-xl flex items-center justify-center mb-4 bg-[#2D8CFF]/15 text-[#2D8CFF]"><c.icon className="w-5 h-5" /></div>
            <h3 className="font-semibold mb-1.5">{c.title}</h3>
            <p className="text-sm opacity-70 leading-relaxed">{c.desc}</p>
          </div>
        ))}
      </div>
    </section>
    <section className="max-w-7xl mx-auto px-5 lg:px-8 pb-20">
      <div className="glass-card rounded-2xl p-8 text-center">
        <h2 className="text-xl font-bold">Contact our support team</h2>
        <p className="text-sm opacity-70 mt-2">Email us and we'll get back to you.</p>
        <a href={`mailto:${PUBLIC_CONTACT_EMAIL}`} data-testid="help-email"
          className="inline-flex items-center gap-2 mt-5 px-6 py-3 rounded-full text-sm font-semibold text-white" style={{ background: 'linear-gradient(135deg,#1E3A5F,#2D8CFF)' }}>
          <Mail className="w-4 h-4" /> {PUBLIC_CONTACT_EMAIL}
        </a>
      </div>
    </section>
  </PublicLayout>
);

export default Help;
